import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	closeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeLabel: {
		id: 'servicedesk-insight-object-graph.graph-header.close-label',
		defaultMessage: 'Close',
		description: 'Label for button that closes the CMDB Object graph view',
	},
});
export default messages;
